import {BrowserRouter , Routes, Route} from 'react-router-dom';
import { useLocation, useNavigate } from 'react-router-dom';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import LoginPage from './pages/login';
import ProtectedRoute from './pages/common/ProtectedRoute';
import TopMenu from './Layouts/SideMenu';
import FirmClients from './pages/FirmClients';

import Glaccount from './pages/gl_accounts'; 

import Home from './pages/Home';
import Messages from './pages/Messages';
import GenerateCUDORDS from './pages/GenerateCUDORDS';
import { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";

function Layout() {
  const location = useLocation();
  const navigate = useNavigate();
  const [showSessionPopup, setShowSessionPopup] = useState(sessionStorage.getItem("sessionExpired") === "true");

  useEffect(()=> {
    const token = localStorage.getItem("bookToken");
    const expiryTime = localStorage.getItem("bookExpiryTime");
    if(!token || !expiryTime) {
      return;
    }
    const currentTime = new Date().getTime();
    const remainingTime = Number(expiryTime) - currentTime;
    if(remainingTime <= 0) {
      localStorage.clear();
      sessionStorage.setItem("sessionExpired", "true");
      setShowSessionPopup(true);
      return;
    }
    const timer = setTimeout(() => {
      localStorage.clear();
      sessionStorage.setItem("sessionExpired", "true");
      setShowSessionPopup(true);
    }, remainingTime);
    return () => clearTimeout(timer);
  }, [navigate]);

  const handleSessionExpired = () => {
    sessionStorage.setItem("sessionExpired", "false");
    setShowSessionPopup(false)
    navigate("/login")
  }
  return (
    <div>
        <>
        {location.pathname !=="/" && location.pathname !=="/login" && <TopMenu/>}
         <Routes>
          <Route path="/login" element={<LoginPage />} />
           <Route path="/">
            <Route index element={<LoginPage/>} />
          </Route>
          <Route path="/Pages/Home">
            <Route index element={<ProtectedRoute><Home /></ProtectedRoute>} />
          </Route>
          <Route path="/Pages/FirmClients">
            <Route index element={<ProtectedRoute><FirmClients /></ProtectedRoute>} />
          </Route>

          <Route path="/Pages/gl_accounts">
            <Route index element={<ProtectedRoute>< Glaccount/></ProtectedRoute>} />
          </Route>

          <Route path="/Pages/Messages">
            <Route index element={<ProtectedRoute><Messages /></ProtectedRoute>} />
          </Route>
          <Route path="/Pages/GenerateCUDORDS">
            <Route index element={<ProtectedRoute><GenerateCUDORDS /></ProtectedRoute>} />
          </Route>
         </Routes>
         <Dialog header="Session Expired" visible={showSessionPopup} baseZIndex={99999} closable={false} modal style={{width: '25rem'}}>
          <p>Your session has expired. Please login again.</p>
          <div className='flex justify-content-end mt-4'>
            <Button label="OK" onClick={handleSessionExpired}/>
          </div>
         </Dialog>
       </>
      {/* <h1>Hello World !!!</h1> */}
    </div>
  );
}

function App() {
  return (
  <BrowserRouter>
    <Layout />
  </BrowserRouter>
  );
}

export default App;
